import { c as _c } from "react/compiler-runtime";
import { Item as DSItem, ItemAvatar as DSItemAvatar } from "@opensea/ui-kit";
import { useRenderImage } from "../../providers/RenderImageProvider";
export function ItemAvatar(t0) {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    renderImage
  } = useRenderImage();
  let t1;
  if ($[2] !== props.children) {
    t1 = props.children ? {} : {
      frameTime: 1
    };
    $[2] = props.children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderImageProps = t1;
  let t2;
  if ($[4] !== props || $[5] !== renderImage || $[6] !== renderImageProps) {
    t2 = <DSItemAvatar renderImage={renderImage} {...renderImageProps} {...props} />;
    $[4] = props;
    $[5] = renderImage;
    $[6] = renderImageProps;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export const Item = DSItem;